function liveAgenda() {
    var nodeId = $('.live-agenda').data("node");
    $.ajax({
        url: window.siteSettings.apihost + "/umbraco/api/GetLatestContentApi/GetLatestContent?nodeId=" + nodeId
    }).done(function (result) {

        $(".content__rte").html(result);
        pageUpdated();

        blurredImageLoad();

    });
    if ($(".esdh-audio ul").length) {
        $.ajax({
            url: window.siteSettings.apihost + "/umbraco/surface/ESDHAudioAccordionsSurface/EsdhAudioLinkListForLiveAgenda?nodeId=" + nodeId
        }).done(function (result) {
            $(".live-agenda__audio ul").empty().append(result);
        });
    }

    //$.when ?
}

function pageUpdated() {
    var message = $(".live-agenda-updated").html();
    var now = moment().format('HH:mm:ss');
    $('.live-updated').remove();
    $(".content__rte").before('<div class="live-updated"><strong>' + message + ' ' + now + ' </strong></div>');

}

$(function () {
    if ($('.live-agenda').length > 0) {
        pageUpdated();
        setInterval(liveAgenda, 20 * 1000); //20sec
    }
});
